import script from "./CommentInboxList.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentInboxList.vue?vue&type=script&setup=true&lang=js"

import "./CommentInboxList.vue?vue&type=style&index=0&id=36e5ce82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e5ce82"]])

export default __exports__